import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["exportButton"]
  connect(){
    this.exportButtonTarget.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(localStorage)));
    this.exportButtonTarget.setAttribute('download', "log.txt");
  }
}
